import { render, staticRenderFns } from "./Drawing.vue?vue&type=template&id=33afcf88&"
import script from "./Drawing.vue?vue&type=script&lang=js&"
export * from "./Drawing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports